import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function ConstructionPageBanner({ bannerImage, bannerTitle }) {
  return ( 
      <section
        className="common-banner-sec common-flex-center construction-page-banner"
        style={{
          backgroundImage: `url(${apiUrl.apiUrl + `/` + bannerImage})`,
        }}
      >
        <div className="overlay"></div>
        <Container fluid>
          <Row className="banner-text-center">
            <Col md={4}>
              <div className=" ">
                <h1 className="common-head whiteColor">
                  {bannerTitle}
                </h1>
              </div>
            </Col>
          </Row>
        </Container>
      </section> 
  );
}

export default ConstructionPageBanner;
